import { ADMIN_UTILITIES_ROUTES } from '@routes';
import { RouteObject } from 'react-router-dom';
import ErrorPage from '../error-page';

export const adminUtilitiesRoutes: RouteObject[] = [
  {
    path: ADMIN_UTILITIES_ROUTES.MERGE_USERS,
    errorElement: <ErrorPage />,
    children: [
      {
        async lazy() {
          const { MergeUsersWrapper } = await import('@features/adminUtilities/MergeUsersWrapper');

          return { Component: MergeUsersWrapper };
        },
        index: true,
        errorElement: <ErrorPage />,
      },
    ],
  },
  {
    path: ADMIN_UTILITIES_ROUTES.CREATE_LICENSE_CODES,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        errorElement: <ErrorPage />,
        async lazy() {
          const { CreateLicenseCodesWrapper } = await import('@features/adminUtilities/CreateLicenseCodesWrapper');

          return { Component: CreateLicenseCodesWrapper };
        },
      },
    ],
  },
];
